import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["levelStSection", "levelLaSection"]
  static values = {
    stStyleId: String,
    laStyleId: String
  }

  connect() {
    this._boundUpdate = this._updateVisibility.bind(this)
    const form = this.element.closest("form")
    if (form) {
      form.addEventListener("change", this._boundUpdate)
      this._updateVisibility()
    }
  }

  disconnect() {
    const form = this.element.closest("form")
    if (form) form.removeEventListener("change", this._boundUpdate)
  }

  _updateVisibility() {
    const selected = this._getSelectedStyleIds()

    if (this.hasLevelStSectionTarget) {
      this.levelStSectionTarget.classList.toggle("d-none", !this.stStyleIdValue || !selected.includes(this.stStyleIdValue))
    }
    if (this.hasLevelLaSectionTarget) {
      this.levelLaSectionTarget.classList.toggle("d-none", !this.laStyleIdValue || !selected.includes(this.laStyleIdValue))
    }
  }

  _getSelectedStyleIds() {
    const form = this.element.closest("form")
    if (!form) return []
    const inputs = form.querySelectorAll('input[name="user[dance_style_ids][]"]:checked')
    return Array.from(inputs).map(inp => inp.value)
  }
}
